import React from 'react';
import { FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const ContactSection = () => {
  return (
    <section className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <div style={{ maxWidth: '600px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>

          <div className="contact-item">
            <div className="contact-icon"><FaPhone /></div>
            <div>
              <h4>Phone</h4>
              <p><a href="tel:+14377846664">+1 437 784 6664</a></p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon"><FaEnvelope /></div>
            <div>
              <h4>Email</h4>
              <p><a href="mailto:admin@fasttrackcollege.ca">admin@fasttrackcollege.ca</a></p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon"><FaClock /></div>
            <div>
              <h4>Working Hours</h4>
              <p>Monday - Friday: 9:00 AM - 9:00 PM</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
